module.exports = __webpack_public_path__ + "img/Oracle_island_treasure.d4faf4dc.png";